import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { DashboardService } from '@src/domain/services';

/** 統計資訊 */
interface StatisticsInfo extends DashboardService.StatisticsBo {}

export interface DashboardState {
  statisticsInfo: StatisticsInfo | null
}

/** Dashboard */
export const dashboardSlice = createSlice({
  name: 'dashboard',
  initialState: {
    /** 統計資訊 */
    statisticsInfo: null
  } as DashboardState,
  reducers: {
    setStatisticsInfo(state, action: PayloadAction<StatisticsInfo>) {
      state.statisticsInfo = action.payload
    },
    clearStatisticsInfo(state) {
      state.statisticsInfo = null
    }
  },
});

export const dashboardReducer = dashboardSlice.reducer
export const dashboardActions = dashboardSlice.actions
